import { fetchJobDetailService, fetchJobDetailServiceStatic } from "store/services/jobs/fetchJobDetail"
import { cache } from 'react'
import configuredAxios from 'helpers/configuredAxios'
// export const revalidate = 3600
export const handleFetchJobDetail = cache(async (params: any) => {
  const jobId = params?.jobId?.split('-')?.pop?.()
  if (jobId && Number(jobId)) {
    const querys = {
      jobId: jobId,
      status: 'public',
      serverAccessToken: null
    }
    querys.status = 'public'
    const data = await fetchJobDetailService(querys)
      .then(({ data: { data } }) => data)
      .catch(() => ({ error: true }))
    return { data, jobId }
  } else {
    return { data: { error: true, message: 'Error: Invalid link address' }, jobId: null }
  }
})

export const handleFetchJobDetailStatic = cache(async (params: any) => {
  const jobId = params?.jobId?.split('-')?.pop?.()
  if (jobId && Number(jobId)) {
    const data = await fetchJobDetailServiceStatic(jobId)
      .then(({ data: { data } }) => data)
      .catch(() => ({ error: true }))
    return { data, jobId }
  } else {
    return { data: { error: true, message: 'Error: Invalid link address' }, jobId: null }
  }
})

export const fetchSeo = cache(async (lang, jobId) => {
  const axios = await configuredAxios('apiGo')
  const seoData = await axios.get(`/web/job_detail_seo/${jobId}?lang=${lang}`)
    .then(res => res.data.data)

  return seoData
})

export const fetchUtm = async (params) => {
  const axios = await configuredAxios('auth')
  const data = await axios.post('/store-user-utm', { params })
    .then(res => res?.data?.data)

  return data
}

export const fetchGoogleSeo = (async (jobId, lang) => {
  let result = {}
  const axios = await configuredAxios('apiGo')
  await axios.get(`/web/job_detail_google_seo/${jobId}?lang = ${lang}`)
    .then(res => {
      const data = res?.data?.data || {}
      result = JSON.stringify(data)
    })
  return result
})

export const fetchPageData = cache(async (lang, jobId, source) => {
  const axios = await configuredAxios('apiGo')
  const data = await axios.get(`/web/job_detail/${jobId}?lang=${lang}&source=${source}`)
    .then(res => res?.data?.data)

  return data
})